export default __webpack_public_path__ + "static/media/Sale.b8575634.png";